import React, { useEffect, useMemo, useState } from 'react';
import {
  Table,
  Button,
  Select,
  Input,
  Card,
  Row,
  Col,
  Modal,
  message,
  Space,
  DatePicker,
  Typography,
  Progress,
  Tooltip
} from 'antd';
import { DownloadOutlined, FilterOutlined, SearchOutlined, SyncOutlined } from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import { URL_API } from '@configs/';
import './style.css';
import { showError } from '@components/notification';
import { communityList, convertLocaltimeToUTC, formatCurrency } from '@utils/utils';
import {
  apiGetOriginalData,
  apiSyncData,
  apiSyncTimeData
} from '@services/ManageDevices/DeviceServices';
import { loadFromLocalStorageObjectFromBase64, saveToLocalStorage } from '@databases/localStorage';
import { contantAuthentication } from '@contants/';
import { get, isEmpty, isNumber } from 'lodash';
import { SelectCommunity } from '@page/Common/SelectCommunity';
import {
  apiGetStatisticsCustomerByDay,
  apiGetStatisticsData
} from '@services/ManageCustomers/CustomerServices';
import { ADMIN_ROLE } from '@utils/constant';
import Chart from '@components/charts/Chart';
import { COLORS } from '@components/charts/chart.constant';
import dayjs from 'dayjs';
import { usePermission } from '@contexts/Auth/UsePermission';
import { Link } from 'react-router-dom';
import FilterAdvanceDrawer from '@components/FilterAdvance';
import ConsumptionCard from './ConsumptionCard';
import { apiGetFavoriteFilters } from '@services/ManageCustomers/FavoriteFilterServices';

const { Option } = Select;

const { RangePicker } = DatePicker;

export default function List() {
  const [data, setData] = useState([]);
  const [flagSearch, setFlagSearch] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedCommunity, setSelectedCommunity] = useState('HP');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [rangeDateString, setRangeDateString] = useState([
    moment().subtract(1, 'day').format('YYYY-MM-DD'),
    moment().format('YYYY-MM-DD')
  ]);
  const [serialNo, setSerialNo] = useState(null);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const user = JSON.parse(loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH));
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(1, 'day'), // Start date: 1 day ago
    dayjs() // End date: today
  ]);
  const { dailyConsumption } = usePermission();
  const [isOpen, setIsOpen] = useState(false);
  const [dataFilterAdvance, setDataFilterAdvance] = useState({});
  const [favoriteFilters, setFavoriteFilters] = useState([]);
  const [selectedFavoriteFilter, setSelectedFavoriteFilter] = useState(null);
  const [loadingFavoriteFilters, setLoadingFavoriteFilters] = useState(false);
  const openDrawer = () => {
    setIsOpen(true);
  };

  const onDrawerClose = () => {
    setIsOpen(false);
  };

  const fetchFavoriteFilters = async () => {
    try {
      setLoadingFavoriteFilters(true);
      const res = await apiGetFavoriteFilters();
      const customerFilters = (res.data?.data || []).filter(
        (filter) => filter.filter_type === 'customer'
      );
      setFavoriteFilters(
        customerFilters.map((filter) => ({
          label: `${filter.filter_name} (${filter.item_ids?.length || 0} KH)`,
          value: filter.id,
          item_ids: filter.item_ids
        }))
      );
    } catch (error) {
      console.error('Error fetching favorite filters:', error);
    } finally {
      setLoadingFavoriteFilters(false);
    }
  };

  useEffect(() => {
    fetchFavoriteFilters();
  }, []);

  const fetchData = async () => {
    try {
      setSelectedRowKey(null);
      setSelectedRow(null);
      setLoadingFetch(true);
      const res = await apiGetStatisticsCustomerByDay({
        page: currentPage,
        size: pageSize,
        keyWord: search ?? undefined,
        serialNo: serialNo,
        community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
        fromDate: rangeDateString?.length ? rangeDateString[0] : undefined,
        toDate: rangeDateString?.length ? rangeDateString[1] : undefined,
        listCust: selectedFavoriteFilter
          ? favoriteFilters
              .find((filter) => filter.value === selectedFavoriteFilter)
              ?.item_ids?.join(',')
          : undefined,
        ...dataFilterAdvance
      });
      setData(
        res.data?.data?.map((item, index) => ({
          ...item,
          stt: (currentPage - 1) * pageSize + 1 + index
        }))
      );
      setTotalItems(res.data?.meta?.total);
    } catch (err) {
      showError({ message: 'Something went wrong!' });
      console.log(err);
    } finally {
      setLoadingFetch(false);
    }
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleChangePageSize = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const onChangeDateRange = (dates, dateStrings) => {
    setRangeDateString(dateStrings);
    setDateRange(dates);
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (!search && !dateRange?.length && currentPage === 1) {
  //       setCurrentPage(1);
  //       fetchData();
  //     }
  //   }, 50000);

  //   return () => clearInterval(interval);
  // }, [search, selectedCommunity, dateRange?.length, currentPage, custId]);

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize, flagSearch]);

  const columns = [
    {
      title: 'DBĐD',
      dataIndex: 'code',
      fixed: 'left',
      width: 80,
      render: (text, record) => (
        <p style={{ color: 'blue', margin: 0 }}>
          {`${record?.code}
          `}
        </p>
      )
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'name',
      fixed: 'left',
      width: 180,
      render: (text, record) => (
        <p style={{ color: 'blue', margin: 0 }}>
          {`${record?.name}
          `}
        </p>
      )
    },
    {
      title: 'Khu vực',
      dataIndex: 'zone',
      width: 70
    },
    {
      title: 'DHK',
      dataIndex: 'parent_device',
      width: 70
    },
    {
      title: 'Tuyến',
      dataIndex: 'route',
      width: 80
    },
    {
      title: 'Cỡ ĐH',
      dataIndex: 'size',
      width: 90
    },
    {
      title: 'Thiết bị',
      dataIndex: 'serial_no',
      width: 100,
      render: (text, record) => (
        <p style={{ color: 'blue', margin: 0 }}>{`SN:${record.serial_no}/ IMEI:${record.imei}`}</p>
      )
    },
    {
      title: 'Ngày thống kê',
      dataIndex: 'denseData_startCollectionTime',
      key: 'denseData_startCollectionTime',
      render: (_, record) => (
        <>
          {record?.denseData_startCollectionTime
            ? record?.denseData_startCollectionTime
            : 'Chưa có dữ liệu'}
        </>
      ),

      width: 150
    },
    {
      title: 'Chỉ số tại thời điểm 00:00 (lít)',
      dataIndex: 'start_meter_reading_at_day',
      key: 'start_meter_reading_at_day',
      render: (_, record) => (
        <>
          {isNumber(record?.start_meter_reading_at_day)
            ? formatCurrency(record?.start_meter_reading_at_day)
            : '-'}
        </>
      ),
      width: 150
    },
    {
      title: 'Tiêu thụ trong ngày (lít)',
      dataIndex: 'water_consumption_of_the_day',
      key: 'water_consumption_of_the_day',
      render: (_, record) => (
        <>
          {isNumber(record?.water_consumption_of_the_day)
            ? formatCurrency(record?.water_consumption_of_the_day)
            : '-'}
        </>
      ),
      width: 120
    },
    {
      title: 'Lượng nước tiêu thụ qua các giờ (lít)',
      children: [
        ...Array.from({ length: 24 }, (_, index) => ({
          title: `${index}:00`,
          dataIndex: `hour${index}`,
          key: `hour${index}`,
          width: 80,
          render: (_, record) => (
            <>
              {isNumber(record?.diffirenceOfTheFlowWaterMeter?.[index])
                ? formatCurrency(record?.diffirenceOfTheFlowWaterMeter?.[index])
                : '-'}
            </>
          )
        }))
      ]
    }
  ];

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSerialNoChange = (e) => {
    setSerialNo(e.target.value);
  };

  const [loading, setLoading] = useState(false);
  const handleExportExcelButtonClick = async () => {
    let user = loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH);
    if (!isEmpty(user)) {
      user = JSON.parse(user);
    }
    setLoading(true);
    const response = await axios.get(
      `${URL_API}/api/customer/v2/statistics-customer-by-day/export`,
      {
        params: {
          keyWord: search ?? undefined,
          serialNo: serialNo,
          community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
          fromDate: rangeDateString?.length ? rangeDateString[0] : undefined,
          toDate: rangeDateString?.length ? rangeDateString[1] : undefined,
          listCust: selectedFavoriteFilter
            ? favoriteFilters
                .find((filter) => filter.value === selectedFavoriteFilter)
                ?.item_ids?.join(',')
            : undefined,
          ...dataFilterAdvance
        },
        headers: {
          Authorization: `Bearer ${user?.accessToken}`
        },
        responseType: 'blob'
      }
    );
    const dateKey = moment().format('YYYYMMDD.HHmmss');
    const type = response.headers['content-type'];
    const blob = new Blob([response.data], { type: type });
    const link1 = document.createElement('a');
    link1.href = window.URL.createObjectURL(blob);
    link1.setAttribute('download', `Thong_ke_tieu_thu_theo ngày_${dateKey}.xlsx`);
    document.body.appendChild(link1);
    link1.click();
    setLoading(false);
  };
  const [loadingSync, setLoadingSync] = useState(false);
  const handleSyncButtonClick = async () => {
    try {
      setLoadingSync(true);
      const res = await apiSyncTimeData();
      // message.success('Cập nhật thành công !');
      fetchData();
    } catch (e) {
      console.log(e);
      message.error('Có lỗi xảy ra !');
    } finally {
      setLoadingSync(false);
    }
  };

  const handleRowClick = async (row) => {
    if (!row?.diffirenceOfTheFlowWaterMeter?.length) {
      showError('Khách hàng không có dữ liệu ngày hôm nay!');
      return;
    }
    setSelectedRowKey(row?.stt);
    setSelectedRow(row);
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };

  const dataCharts = [
    {
      name: 'Tiêu thụ giờ',
      data: selectedRow
        ? selectedRow?.diffirenceOfTheFlowWaterMeter?.map((value) => (isNumber(value) ? value : 0))
        : [],
      type: 'bar'
    }
  ];

  useEffect(() => {
    handleSyncButtonClick();
  }, []);

  return (
    <div>
      <Row justify="space-between" align="middle">
        <Col>
          <Typography.Title level={4} style={{ color: '#0051A9' }}>
            Thống kê tiêu thụ theo ngày nhiều khách hàng
          </Typography.Title>
        </Col>
        {dailyConsumption.export && (
          <Col>
            <Button
              icon={<DownloadOutlined />}
              onClick={handleExportExcelButtonClick}
              loading={loading}
              style={{
                backgroundColor: '#EAF5EF',
                borderColor: '#EAF5EF',
                color: '#0051A9',
                height: '36px',
                fontWeight: '500'
              }}>
              Xuất báo cáo
            </Button>
          </Col>
        )}
      </Row>
      <Card>
        <Row gutter={[8, 8]} style={{ marginBottom: '16px' }}>
          {/* <Col md={4} xs={6}>
            <Input
              value={serialNo}
              onChange={handleSerialNoChange}
              placeholder="Tìm kiếm số serial..."
              style={{ width: '100%', marginBottom: '16px', height: '36px' }}
            />
          </Col> */}
          <Col md={1} xs={1}>
            <Button
              icon={<FilterOutlined />}
              onClick={openDrawer}
              style={{
                backgroundColor: '#F4F5F7',
                color: '#626D7C',
                border: 'none',
                width: '100%'
              }}
            />
          </Col>
          <Col md={5} xs={8}>
            <Select
              placeholder="Chọn Bộ lọc theo dõi..."
              value={selectedFavoriteFilter}
              onChange={(value) => {
                setSelectedFavoriteFilter(value);
                setCurrentPage(1);
              }}
              loading={loadingFavoriteFilters}
              allowClear
              options={favoriteFilters}
              style={{ width: '100%', height: '36px' }}
            />
          </Col>
          <Col md={4} xs={6}>
            <Input
              style={{ height: '36px', width: '100%', fontSize: '18px' }}
              size="small"
              placeholder="Tìm kiếm theo mã tên KH..."
              value={search}
              onChange={handleSearchChange}
              onPressEnter={() => {
                setCurrentPage(1);
                setFlagSearch(!flagSearch);
              }}
            />
          </Col>
          <Col md={6} xs={8}>
            <RangePicker
              value={dateRange}
              onChange={onChangeDateRange}
              style={{ width: '100%', height: '36px', fontSize: '18px' }}
              format="YYYY-MM-DD"
              placeholder={['Từ ngày', 'Đến ngày']}
              defaultPickerValue={[dayjs().subtract(1, 'month'), dayjs()]}
            />
          </Col>
          <Col md={4} xs={6}>
            <SelectCommunity value={selectedCommunity} onChange={setSelectedCommunity} />
          </Col>
          <Col md={4} xs={6}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {
                if (!dateRange || !dateRange[0] || !dateRange[1]) {
                  message.error('Vui lòng chọn khoảng thời gian!');
                  return;
                }
                setCurrentPage(1);
                setFlagSearch(!flagSearch);
              }}
              style={{
                height: '36px',
                backgroundColor: '#0051A9',
                borderColor: '#0051A9',
                fontSize: '18px'
              }}>
              Tìm kiếm
            </Button>
          </Col>
          <ConsumptionCard
            rangeDateString={rangeDateString}
            dataFilterAdvance={dataFilterAdvance}
            flagSearch={flagSearch}
            keyWord={search}
            serialNo={serialNo}
            selectedFavoriteFilter={selectedFavoriteFilter}
            favoriteFilters={favoriteFilters}
          />
        </Row>
        <Table
          bordered
          // size="middle"
          loading={loadingFetch}
          dataSource={data || []}
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalItems,
            showSizeChanger: true,
            onChange: handleChangePage,
            onShowSizeChange: handleChangePageSize,
            showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          onRow={(record) => ({
            onClick: () => handleRowClick(record), // Click handler for rows
            style: {
              cursor: 'pointer',
              backgroundColor: selectedRowKey === record.stt ? '#e6f7ff' : undefined
            }
          })}
          style={{
            borderRadius: '4px',
            thead: { backgroundColor: '#DBDFE5', color: '#626D7C' },
            fontSize: '30px'
          }}
          scroll={{ x: 'max-content', y: 400 }}
        />
      </Card>
      {selectedRowKey && (
        <>
          <Col>
            <Typography.Title level={4} style={{ marginTop: '8px' }}>
              Biểu đồ thống kê tiêu thụ các giờ trong ngày
            </Typography.Title>
          </Col>
          <Card>
            <Typography.Title style={{ fontSize: '16px' }}>
              {`${selectedRow?.code} - ${selectedRow?.name}`}{' '}
              {`(${selectedRow?.denseData_startCollectionTime})`}
            </Typography.Title>
            <Chart
              options={{
                colors: COLORS,
                chart: {
                  zoom: {
                    enabled: false
                  },
                  toolbar: {
                    show: true
                  }
                },
                plotOptions: {
                  bar: {
                    horizontal: false,
                    columnWidth: '25px',
                    borderRadius: 4
                  }
                },
                fill: {
                  opacity: 1
                },
                dataLabels: {
                  enabled: false
                },
                stroke: {
                  show: true,
                  width: 2,
                  colors: ['transparent']
                },
                labels: [
                  '00',
                  '01',
                  '02',
                  '03',
                  '04',
                  '05',
                  '06',
                  '07',
                  '08',
                  '09',
                  '10',
                  '11',
                  '12',
                  '13',
                  '14',
                  '15',
                  '16',
                  '17',
                  '18',
                  '19',
                  '20',
                  '21',
                  '22',
                  '23'
                ],
                yaxis: {
                  show: true
                },
                grid: {
                  show: true
                },
                tooltip: {
                  y: {
                    formatter: (val) => `${formatCurrency(val)} lít`
                  }
                },
                legend: {
                  horizontalAlign: 'left'
                }
              }}
              type="bar"
              series={dataCharts}
              height={400}
            />
          </Card>
        </>
      )}
      <FilterAdvanceDrawer
        setCurrentPage={setCurrentPage}
        isOpen={isOpen}
        onDrawerClose={onDrawerClose}
        dataFilterAdvance={dataFilterAdvance}
        setDataFilterAdvance={setDataFilterAdvance}
        flagSearch={flagSearch}
        setFlagSearch={setFlagSearch}
      />
    </div>
  );
}
